module.exports = __webpack_public_path__ + "5c114213/img/product-icon-grey.b248963c.svg";